module.exports = __webpack_public_path__ + "assets/img/tab1_02.a43011f4.jpg";